import React, { useState, useEffect } from "react";
import { useQuery } from '@apollo/client';
import Button from '../Email Clients/components/Button';
import Card from '../Email Clients/components/Card';
import CardContent from '../Email Clients/components/CardContent';
import Input from '../Email Clients/components/Input';
import Textarea from '../Email Clients/components/Textarea';
import TemplateSelector from '../Email Clients/components/TemplateSelector';
import Editor from '../Email Clients/components/Editor';
import { listUsersByTeamOne } from '../../graphql/queries';
import { fetchAuthSession } from 'aws-amplify/auth';
import logo from '../../assets/images/Pathways_Logo.png';
import './EmailCampaign.css';

const EmailCampaign = () => {
  const [subject, setSubject] = useState('');
  const [recipientList, setRecipientList] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [template, setTemplate] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState('name'); // Default filter


  const { data: userData } = useQuery(listUsersByTeamOne);// Example Clients
  const clients = userData?.listUserFixes?.items
    ?.filter((u) => u && u.first_name && u.last_name)
    ?.map((u) => ({
      id: u.id,
      thc_email_id: u.thc_email_id,
      name: `${u.first_name.charAt(0).toUpperCase() + u.first_name.slice(1).toLowerCase()} 
  ${u.last_name.charAt(0).toUpperCase() + u.last_name.slice(1).toLowerCase()}`
    }))
    ?.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })) || [];

  /*----------------------*/
  const filteredClients = clients.filter((client) => {
    if (!searchQuery) return true;
    return client[filter]?.toLowerCase().includes(searchQuery.toLowerCase());
  });
  /*----------------------*/
  const handleClientSelection = (checked) => {
    if (checked) {
      setSelectedClients(filteredClients.map(user => ({ email: user.thc_email_id, id: user.id })));
      setRecipientList(filteredClients.map(user => user.thc_email_id).join(", "));
    } else {
      setSelectedClients([]);
      setRecipientList("");
    }
  };

  /*----------------------*/
  const handleUserChange = (e) => {
    const { value, checked } = e.target;
    const userData = JSON.parse(value);

    if (value === "all") {
      handleClientSelection(checked);
    } else {
      setSelectedClients((prev) => {
        const updatedClients = checked
          ? [...prev, userData]
          : prev.filter(user => user.email !== userData.email);
        setRecipientList(updatedClients.map(user => user.email).join(", "));
        return updatedClients;
      });
    }
  };
  /*----------------------*/
  const handleSendEmail = async () => {
    console.log({ subject, recipientList, emailBody, template, selectedClients });

    if ((!selectedClients || selectedClients.length === 0)) {
      alert("⚠️ You must select at least one user.");
      return;
    }
    if (!emailBody || emailBody.trim() === "") {
      alert("⚠️ The email body cannot be empty.");
      return;
    }
    const cleanedBody = emailBody.replace(/<\/?p>/g, "").replace(/<\/?br>/g, "");

    // Send Email
    for (const user of selectedClients) {
      console.log("📩 Sending email to:", user.email);
      console.log("🆔 User ID:", user.id);
      try {
        const employeeUsername = user.email?.split("@")[0];
        console.log("Extracted Username:", employeeUsername);

        if (!user.email) {
          console.error("❌ No email found for user.");
          return;
        }

        console.log("Employee Email", user.email);

        const emailContent = {
          to: user.email?.trim(), // Asegurar que no tenga espacios en blanco
          subject: `Health Collaborative - Pathways to Covearge`,
          body: `
        <html>
    <body style="font-family: Arial, sans-serif; background-color: #f9f9f9; margin: 0; padding: 0;">
      <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f9f9f9; padding: 20px 0;">
        <tr>
          <td align="center">
            <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
        
            <tr>
                <td align="center" style="background-color:rgb(37, 59, 146); color: #ffffff; padding: 20px; border-top-left-radius: 8px; border-top-right-radius: 8px;">
                  <h1 style="margin: 0; font-size: 24px;"> ${subject}</h1>
                </td>
              </tr>
            
              <tr>
                <td style="padding: 20px; color: #333333; line-height: 1.6;">
                  <p style="font-size: 16px; margin: 0 0 20px;">Dear <strong>${employeeUsername}</strong>,</p>
                  <p style="font-size: 16px; margin: 0 0 20px;">${cleanedBody}</p>
    
                  <p style="font-size: 16px; margin: 0 0 20px;">If you have any further questions or need additional support, please don’t hesitate to reach out.</p>
                </td>
              </tr>
              <tr>
                <td align="center" style="padding: 20px;">
                  <a href="https://www.pathwaystocoverage.net/" 
                     style="display: inline-block; padding: 12px 25px; font-size: 16px; color: #ffffff; background-color:rgb(37, 59, 146); text-decoration: none; border-radius: 4px;">
                    Contact us
                  </a>
                </td>
              </tr>
              <tr>
                <td style="padding: 20px; font-size: 14px; color: #777777; text-align: center;">
                  <p style="margin: 0;">This is an automated email. Please do not reply.</p>
                  <p style="margin: 0;">&copy; 2025 Compass Health Collaborative. All Rights Reserved.</p>
                </td>
                                  <!-- 🔹 Unsubscribe Links -->
              </tr>
                    <tr><td style="padding: 20px; font-size: 14px; color: #777777; text-align: center;">
                    <a href="https://yourwebsite.com/unsubscribe" className="mr-4">Unsubscribe</a> |
            <a href="https://www.pathwaystocoverage.net/" className="mx-4">Update Profile</a> |
            <a href="https://www.pathwaystocoverage.net/" className="ml-4">Privacy Policy</a>
                </td></tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
  </html>
        `
        };

        console.log("Sending completion notification to employee:", user.email);
        await invokeLambdaFunction(emailContent);
        console.log("✅ Notification sent to employee.");
      } catch (error) {
        console.error("❌ Error sending notification:", error);
      }
    }
  };

  /*----------------------*/
  const invokeLambdaFunction = async (emailData) => {
    const url = "https://buykqjzjjh.execute-api.us-east-2.amazonaws.com/compassdev/sendemail";

    try {
      // Obtener token de autenticación (si es necesario)
      const session = await fetchAuthSession();
      if (!session || !session.tokens || !session.tokens.idToken) {
        throw new Error("User is not authenticated or token is missing.");
      }
      const idToken = session.tokens.idToken.toString();

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to send email. Error: ${errorText}`);
      }

      const data = await response.json();
      console.log("Lambda function response:", data);
      alert("The Emails sent successfully!");
    } catch (error) {
      console.error("Error invoking Lambda:", error.message);
      alert("Failed to send notification email.");
    }
  };

  return (
    <div className="email-campaign-container">
      <Card>
        <CardContent>
          <header >
            <div className="email-campaign-header" >
              <h2>Mass Email Campaign</h2>
              <img src={logo} alt="logo" className="principal-logo" />
            </div>
          </header>
          <Input
            placeholder="Email Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <label>🔍 Filter clients by:</label>
          <select className="w-full p-2 border rounded-md" onChange={(e) => setFilter(e.target.value)}>
            <option value="name">First Name</option>
            <option value="city">City</option> {/*Otros ejemplo de busqeda*/}
            <option value="county">County</option>

          </select>

          <Input
            placeholder={`Search by ${filter}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <label>Select clients(s):</label>
          <div className="clients-checkboxes">
            <label className="all-users">
              <input
                type="checkbox"
                value="all"
                checked={selectedClients.length === filteredClients.length}
                onChange={(e) => handleClientSelection(e.target.checked)}
              />
              All
            </label>
            {filteredClients.map((user) => (
              <label key={user.email}>
                <input
                  type="checkbox"
                  value={JSON.stringify({ email: user.thc_email_id, id: user.id })}
                  checked={selectedClients.some(u => u.email === user.thc_email_id)}
                  onChange={handleUserChange}
                />
                {user.name}
              </label>
            ))}
          </div>

          <Textarea
            placeholder="Recipients"
            value={recipientList}
            readOnly
          />

          <TemplateSelector setTemplate={setTemplate} setEmailBody={setEmailBody} />

          <Editor value={emailBody} onChange={setEmailBody} />

          <Button onClick={handleSendEmail} className="send-button">
            Send Email
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailCampaign;